import React from "react";
import { PermissionsContext } from "./context";

/**
 * PermissionsProvider
 *
 * This provider uses TanStack Query to fetch and manage user permissions. It's designed to allow
 * for optimistic rendering of content that requires permissions.
 *
 * Key features:
 *
 * 1. Uses keepPreviousData: true in the query configuration.
 * 2. Allows immediate rendering of protected content without waiting for fresh permissions.
 * 3. Handles permission changes safely through backend 403 errors.
 *
 * Optimistic Rendering Strategy:
 *
 * - Permissions are rarely edited, so we don't need to wait for fresh data on every render.
 * - If permissions have changed, the backend will throw a 403 error for unauthorized actions.
 * - After a 403 error, we refetch permissions to update the UI accordingly.
 *
 * Usage: Wrap your app or protected routes with this provider: <PermissionsProvider>
 * <ProtectedContent /> </PermissionsProvider>
 *
 * Then use the usePermissions hook in child components to access permission data.
 */
export function PermissionsProvider({ children }: React.PropsWithChildren) {
  // const { data, error, isLoading, refetch } = useQuery({
  //   ...queryOptions_my_permissions({}),
  // });

  // const value = {
  //   permissions: data?.permissions || [],
  //   refetch,
  //   isLoading,
  //   error: error as Error | null,
  // };

  const value = {
    permissions: [],
    refetch: () => Promise.resolve(),
    isLoading: false,
    error: null,
  };
  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>;
}
